(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (function() {
    var dialog = document.getElementById('age-gate');
    if (!dialog) return;

    if (localStorage.getItem('age_verified') === 'true') return;

    dialog.showModal();

    dialog.querySelector('[data-age-gate-yes]').addEventListener('click', function() {
      localStorage.setItem('age_verified', 'true');
      dialog.close();
    });

    dialog.querySelector('[data-age-gate-no]').addEventListener('click', function() {
      dialog.querySelector('[data-age-gate-prompt]').hidden = true;
      dialog.querySelector('[data-age-gate-rejected]').hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-sidebar"] && !Shopify.designMode) return;
  try {
    (function () {
    var HEADER_OFFSET = 120;
    var BOTTOM_GAP = 24;

    function update() {
      document.querySelectorAll('[data-blog-sidebar-sticky]').forEach(function (sidebar) {
        var top = Math.min(HEADER_OFFSET, window.innerHeight - sidebar.offsetHeight - BOTTOM_GAP);
        sidebar.style.setProperty('--blog-sidebar-top', top + 'px');
      });
    }

    update();
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    document.addEventListener('shopify:section:load', update);

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(update);
      document.querySelectorAll('[data-blog-sidebar-sticky]').forEach(function (sidebar) {
        observer.observe(sidebar);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compact-line-list"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var pillBtn = e.target.closest('[data-compact-row] .compact-line__pill-btn');
      if (!pillBtn) return;
      if (pillBtn.disabled || pillBtn.classList.contains('is-unavailable')) return;

      var row = pillBtn.closest('[data-compact-row]');
      if (!row) return;

      var variantId = pillBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      row.querySelectorAll('.compact-line__pill-btn').forEach(function(b) {
        var active = b === pillBtn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      row.querySelectorAll('.compact-line__detail-item').forEach(function(d) {
        d.classList.toggle('is-active', d.getAttribute('data-detail-for') === variantId);
      });

      var input = row.querySelector('[data-variant-input]');
      if (input) input.value = variantId;
    });

    document.addEventListener('click', function(e) {
      var row = e.target.closest('[data-compact-row]');
      if (!row) return;

      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var input = row.querySelector('[data-qty-input]');
      if (!input) return;

      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 1) value = 1;

      if (minus && value > 1) input.value = value - 1;
      if (plus) input.value = value + 1;
    });

    function initLightbox(container) {
      var lightbox = container.querySelector('[data-compact-lightbox]');
      if (!lightbox) return;

      var imgs = lightbox.querySelectorAll('[data-compact-lightbox-slide]');
      var counter = lightbox.querySelector('[data-compact-lightbox-counter]');
      var closeBtn = lightbox.querySelector('[data-compact-lightbox-close]');
      var prevBtn = lightbox.querySelector('[data-compact-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-compact-lightbox-next]');
      var openers = container.querySelectorAll('[data-compact-gallery-open]');
      var current = 0;
      var lastFocus = null;

      function show(i) {
        if (i < 0) i = imgs.length - 1;
        if (i >= imgs.length) i = 0;
        current = i;
        imgs.forEach(function(img, idx) {
          img.classList.toggle('is-active', idx === i);
        });
        if (counter) counter.textContent = (i + 1) + ' / ' + imgs.length;
      }

      function open(i) {
        lastFocus = document.activeElement;
        show(i);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        // force reflow so the opacity transition runs
        void lightbox.offsetWidth;
        lightbox.classList.add('is-open');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
        var done = function() {
          lightbox.hidden = true;
          lightbox.removeEventListener('transitionend', done);
        };
        lightbox.addEventListener('transitionend', done);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      openers.forEach(function(btn) {
        btn.addEventListener('click', function() {
          open(parseInt(btn.getAttribute('data-compact-gallery-open'), 10) || 0);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', function() { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { show(current + 1); });

      // click on backdrop (not the image itself) closes
      lightbox.addEventListener('click', function(e) {
        if (e.target.closest('[data-compact-lightbox-slide]')) return;
        if (e.target.closest('button')) return;
        close();
      });

      document.addEventListener('keydown', function(e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(current - 1);
        else if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    function initGallery(gallery) {
      var container = gallery.closest('.compact-line') || document;
      initLightbox(container);

      var track = gallery.querySelector('[data-compact-gallery-track]');
      if (!track) return;
      var slides = gallery.querySelectorAll('[data-compact-gallery-slide]');
      var dots = gallery.querySelectorAll('[data-compact-gallery-dot]');
      var prev = gallery.querySelector('[data-compact-gallery-prev]');
      var next = gallery.querySelector('[data-compact-gallery-next]');
      if (slides.length <= 1) return;

      function scrollToIndex(i) {
        var slide = slides[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      function currentIndex() {
        var slideWidth = slides[0].getBoundingClientRect().width;
        if (!slideWidth) return 0;
        return Math.round(track.scrollLeft / slideWidth);
      }

      track.addEventListener('scroll', function() {
        var idx = currentIndex();
        dots.forEach(function(d, i) {
          var active = i === idx;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }, { passive: true });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var i = parseInt(dot.getAttribute('data-compact-gallery-dot'), 10);
          scrollToIndex(i);
        });
      });

      if (prev) {
        prev.addEventListener('click', function() {
          var i = currentIndex() - 1;
          if (i < 0) i = slides.length - 1;
          scrollToIndex(i);
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          var i = currentIndex() + 1;
          if (i >= slides.length) i = 0;
          scrollToIndex(i);
        });
      }
    }

    document.querySelectorAll('[data-compact-gallery]').forEach(initGallery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["edge-shadows"] && !Shopify.designMode) return;
  try {
    (function() {
    function update(wrapper) {
      var track = wrapper.querySelector('[data-edge-track]');
      if (!track) return;
      var maxLeft = track.scrollWidth - track.clientWidth;
      wrapper.classList.toggle('is-at-start', track.scrollLeft <= 1);
      wrapper.classList.toggle('is-at-end', track.scrollLeft >= maxLeft - 1);
    }

    function updateAll() {
      document.querySelectorAll('[data-edge-shadow]').forEach(update);
    }

    // Scroll events don't bubble, but they can be caught on the way down.
    document.addEventListener('scroll', function(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var wrapper = target.closest('[data-edge-shadow]');
      if (wrapper && target.hasAttribute('data-edge-track')) update(wrapper);
    }, true);

    window.addEventListener('resize', updateAll);
    window.addEventListener('load', updateAll);

    // Rows inserted later (cart drawer, quick view) get their first check here.
    var pending = false;
    new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() {
        pending = false;
        updateAll();
      });
    }).observe(document.body, { childList: true, subtree: true });

    updateAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    }

    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var FETCH_LIMIT = 10; /* endpoint max; gives the ranker more candidates */

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeRegex(value) {
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function productImage(product) {
      if (typeof product.image === 'string') {
        return product.image;
      }
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') {
          return product.featured_image;
        }
        return product.featured_image.url || '';
      }
      return '';
    }

    function sized(url, width) {
      if (!url) {
        return '';
      }
      try {
        var parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (e) {
        return url;
      }
    }

    /* Re-rank so the best TITLE match wins, regardless of Shopify's order. */
    function rankProducts(query, products) {
      var normalized = query.toLowerCase().trim();
      var words = normalized.split(/\s+/).filter(Boolean);

      return products
        .map(function (product, index) {
          var title = (product.title || '').toLowerCase();
          var vendor = (product.vendor || '').toLowerCase();
          var haystack = title + ' ' + vendor;
          var score = 0;

          if (title === normalized) {
            score += 1000;
          }
          if (title.indexOf(normalized) === 0) {
            score += 200;
          } else if (normalized.length > 1 && title.indexOf(normalized) !== -1) {
            score += 120;
          }
          if (words.every(function (word) { return title.indexOf(word) !== -1; })) {
            score += 80;
          }
          if (words.every(function (word) { return haystack.indexOf(word) !== -1; })) {
            score += 40;
          }
          words.forEach(function (word) {
            if (title.indexOf(word) !== -1) {
              score += 8;
            }
          });
          words.forEach(function (word) {
            if (new RegExp('\\b' + escapeRegex(word) + '\\b').test(title)) {
              score += 6;
            }
          });

          return { product: product, score: score, index: index };
        })
        .sort(function (a, b) {
          return b.score - a.score || a.index - b.index;
        })
        .map(function (entry) {
          return entry.product;
        });
    }

    function fetchSuggest(query, signal) {
      var url = ROOT + 'search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product'
        + '&resources[limit]=' + FETCH_LIMIT
        + '&resources[options][unavailable_products]=last';

      return fetch(url, { signal: signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data || !data.resources || !data.resources.results) {
            return [];
          }
          return data.resources.results.products || [];
        });
    }

    /* ---- Header dropdown ---- */
    function initDropdown(root) {
      var input = root.querySelector('[data-predictive-input]');
      var results = root.querySelector('[data-predictive-results]');
      if (!input || !results) {
        return;
      }

      var displayLimit = parseInt(root.getAttribute('data-limit'), 10) || 6;
      var searchUrl = root.getAttribute('data-search-url') || (ROOT + 'search');
      var msgSearching = root.getAttribute('data-i18n-searching') || '';
      var msgEmpty = root.getAttribute('data-i18n-empty') || '';
      var msgViewAll = root.getAttribute('data-i18n-viewall') || '';

      var controller = null;
      var debounceTimer = null;
      var activeIndex = -1;

      function open() {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      }

      function viewAllLink(query) {
        return '<a class="predictive__viewall" href="'
          + escapeHtml(searchUrl + '?q=' + encodeURIComponent(query))
          + '">' + escapeHtml(msgViewAll) + '</a>';
      }

      function render(query, products) {
        var items = products.slice(0, displayLimit);
        var html = '';

        if (items.length) {
          html += '<ul class="predictive__list" role="presentation">';
          items.forEach(function (product, idx) {
            var image = sized(productImage(product), 120);
            var thumb = image
              ? '<span class="predictive__thumb"><img src="' + escapeHtml(image) + '" alt="" width="44" height="44" loading="lazy"></span>'
              : '<span class="predictive__thumb predictive__thumb--empty"></span>';
            html += '<li role="presentation">'
              + '<a class="predictive__item" role="option" id="predictive-opt-' + idx + '" href="' + escapeHtml(product.url) + '">'
              + thumb
              + '<span class="predictive__text">'
              + (product.vendor ? '<span class="predictive__vendor">' + escapeHtml(product.vendor) + '</span>' : '')
              + '<span class="predictive__title">' + escapeHtml(product.title) + '</span>'
              + '</span></a></li>';
          });
          html += '</ul>';
        } else {
          html += '<p class="predictive__empty">' + escapeHtml(msgEmpty) + '</p>';
        }

        html += viewAllLink(query);
        results.innerHTML = html;
        activeIndex = -1;
        open();
      }

      function showMessage(message) {
        results.innerHTML = '<p class="predictive__empty">' + escapeHtml(message) + '</p>';
        open();
      }

      function runSearch() {
        var query = input.value.trim();
        if (query.length < 2) {
          close();
          return;
        }
        if (controller) {
          controller.abort();
        }
        controller = ('AbortController' in window) ? new AbortController() : null;
        if (msgSearching) {
          showMessage(msgSearching);
        }
        fetchSuggest(query, controller ? controller.signal : undefined)
          .then(function (products) {
            if (input.value.trim() !== query) {
              return;
            }
            render(query, rankProducts(query, products));
          })
          .catch(function () { /* aborted or offline -- ignore */ });
      }

      function updateActive(options) {
        options.forEach(function (option, i) {
          if (i === activeIndex) {
            option.classList.add('is-active');
            option.setAttribute('aria-selected', 'true');
            input.setAttribute('aria-activedescendant', option.id);
            option.scrollIntoView({ block: 'nearest' });
          } else {
            option.classList.remove('is-active');
            option.removeAttribute('aria-selected');
          }
        });
        if (activeIndex < 0) {
          input.removeAttribute('aria-activedescendant');
        }
      }

      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runSearch, 200);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML) {
          open();
        }
      });

      input.addEventListener('keydown', function (event) {
        var options = results.querySelectorAll('.predictive__item');

        if (event.key === 'ArrowDown') {
          if (results.hidden || !options.length) {
            return;
          }
          event.preventDefault();
          activeIndex = Math.min(activeIndex + 1, options.length - 1);
          updateActive(options);
        } else if (event.key === 'ArrowUp') {
          if (results.hidden || !options.length) {
            return;
          }
          event.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          updateActive(options);
        } else if (event.key === 'Enter') {
          if (!results.hidden && activeIndex >= 0 && options[activeIndex]) {
            event.preventDefault();
            window.location.href = options[activeIndex].getAttribute('href');
          }
        } else if (event.key === 'Escape') {
          close();
        }
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) {
          close();
        }
      });
    }

    /* Predictive search returns prices as plain numbers ("206.61"). */
    function formatPrice(value) {
      var amount = parseFloat(value);
      if (isNaN(amount)) return '';
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return amount.toFixed(2);
      }
    }

    /* ---- Search results "Top matches" band ---- */
    function initTopMatches(el) {
      var terms = (el.getAttribute('data-terms') || '').trim();
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
      var grid = el.querySelector('[data-predictive-top-grid]');
      if (!terms || !grid) {
        return;
      }

      fetchSuggest(terms)
        .then(function (products) {
          var ranked = rankProducts(terms, products).slice(0, limit);
          if (!ranked.length) {
            return; /* nothing strong -- leave the band hidden */
          }
          /* Skip the band when the first results already show these products */
          var resultLinks = Array.prototype.slice.call(document.querySelectorAll('.search-page__results a[href*="/products/"]'))
            .slice(0, limit * 4)
            .map(function (a) { return a.getAttribute('href').split('?')[0]; });
          var allShown = ranked.every(function (product) {
            return resultLinks.indexOf(String(product.url).split('?')[0]) !== -1;
          });
          if (allShown) {
            return;
          }
          var fromLabel = el.getAttribute('data-i18n-from') || '[price]';
          var html = '';
          ranked.forEach(function (product) {
            var image = sized(productImage(product), 300);
            html += '<a class="search-top__card" href="' + escapeHtml(product.url) + '">'
              + '<span class="search-top__img">'
              + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '')
              + '</span>'
              + '<span class="search-top__meta">'
              + (product.vendor ? '<span class="search-top__vendor">' + escapeHtml(product.vendor) + '</span>' : '')
              + '<span class="search-top__title">' + escapeHtml(product.title) + '</span>'
              + (product.price ? '<span class="search-top__price">' + escapeHtml(fromLabel.replace('[price]', formatPrice(product.price))) + '</span>' : '')
              + '</span></a>';
          });
          grid.innerHTML = html;
          el.hidden = false;
        })
        .catch(function () { /* offline -- leave the band hidden */ });
    }

    ready(function () {
      var dropdowns = document.querySelectorAll('[data-predictive-search]');
      dropdowns.forEach(initDropdown);

      var band = document.querySelector('[data-predictive-top-matches]');
      if (band) {
        initTopMatches(band);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-badge"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__promoBadgeInit) return;
    window.__promoBadgeInit = true;

    var supportsPopover = typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('popover');
    var openBadge = null;
    var pinned = false;
    var closeTimer = null;
    var placeFrame = null;
    var uid = 0;

    function parts(badge) {
      return {
        trigger: badge.querySelector('[data-promo-trigger]'),
        popover: badge.querySelector('[data-promo-popover]')
      };
    }

    /* Ids are assigned here rather than in Liquid so cards rendered twice on a
       page, or cloned by the deals filter, never share a popover id. */
    function ensureIds(badge) {
      var p = parts(badge);
      if (!p.trigger || !p.popover) return;
      if (!p.popover.id || document.getElementById(p.popover.id) !== p.popover) {
        uid += 1;
        p.popover.id = 'promo-popover-' + uid;
      }
      p.trigger.setAttribute('aria-controls', p.popover.id);
      p.trigger.setAttribute('aria-describedby', p.popover.id);
    }

    function initAll() {
      var badges = document.querySelectorAll('[data-promo-badge]');
      for (var i = 0; i < badges.length; i++) ensureIds(badges[i]);
    }

    function isShown(popover) {
      if (supportsPopover) {
        try { return popover.matches(':popover-open'); } catch (e) { return false; }
      }
      return popover.classList.contains('is-open');
    }

    function place(badge) {
      var p = parts(badge);
      if (!p.trigger || !p.popover) return;
      var rect = p.trigger.getBoundingClientRect();
      var viewportWidth = document.documentElement.clientWidth;
      var viewportHeight = window.innerHeight;
      var gap = 8;
      var edge = 8;
      var width = p.popover.offsetWidth;
      var height = p.popover.offsetHeight;

      var top = rect.bottom + gap;
      if (top + height > viewportHeight - edge && rect.top - gap - height >= edge) {
        top = rect.top - gap - height;
      }
      var left = Math.min(rect.left, viewportWidth - width - edge);
      if (left < edge) left = edge;

      p.popover.style.top = Math.round(top) + 'px';
      p.popover.style.left = Math.round(left) + 'px';
    }

    function hide(badge) {
      if (!badge) return;
      var p = parts(badge);
      if (p.popover) {
        if (supportsPopover) {
          try { if (isShown(p.popover)) p.popover.hidePopover(); } catch (e) {}
        }
        p.popover.classList.remove('is-open');
      }
      if (p.trigger) p.trigger.setAttribute('aria-expanded', 'false');
      if (openBadge === badge) {
        openBadge = null;
        pinned = false;
      }
    }

    function show(badge, pin) {
      clearTimeout(closeTimer);
      if (openBadge && openBadge !== badge) hide(openBadge);
      if (badge.hidden || !badge.isConnected) return;
      ensureIds(badge);
      var p = parts(badge);
      if (!p.trigger || !p.popover) return;
      if (!isShown(p.popover)) {
        if (supportsPopover) {
          try { p.popover.showPopover(); } catch (e) { p.popover.classList.add('is-open'); }
        } else {
          p.popover.classList.add('is-open');
        }
      }
      p.trigger.setAttribute('aria-expanded', 'true');
      openBadge = badge;
      pinned = !!pin;
      place(badge);
    }

    function closest(target, selector) {
      return target && target.closest ? target.closest(selector) : null;
    }

    /* Mouse hover: open on enter, close shortly after leaving (the delay lets
       the pointer cross the gap into the popover). */
    document.addEventListener('pointerover', function(e) {
      if (e.pointerType !== 'mouse') return;
      var badge = closest(e.target, '[data-promo-badge]');
      if (!badge) return;
      clearTimeout(closeTimer);
      if (openBadge !== badge) show(badge, false);
    });

    document.addEventListener('pointerout', function(e) {
      if (e.pointerType !== 'mouse') return;
      var badge = closest(e.target, '[data-promo-badge]');
      if (!badge || badge !== openBadge || pinned) return;
      if (e.relatedTarget && badge.contains(e.relatedTarget)) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        if (!pinned) hide(badge);
      }, 150);
    });

    /* Click / tap / Enter / Space: toggle and pin. Clicking elsewhere closes. */
    document.addEventListener('click', function(e) {
      var trigger = closest(e.target, '[data-promo-trigger]');
      if (trigger) {
        var badge = trigger.closest('[data-promo-badge]');
        if (!badge) return;
        e.preventDefault();
        if (openBadge === badge && pinned) {
          hide(badge);
        } else {
          show(badge, true);
        }
        return;
      }
      if (openBadge && !openBadge.contains(e.target)) hide(openBadge);
    });

    /* Keyboard focus */
    document.addEventListener('focusin', function(e) {
      var trigger = closest(e.target, '[data-promo-trigger]');
      if (!trigger) return;
      var badge = trigger.closest('[data-promo-badge]');
      if (badge && openBadge !== badge) show(badge, false);
    });

    document.addEventListener('focusout', function(e) {
      if (!openBadge || pinned) return;
      if (!openBadge.contains(e.target)) return;
      if (e.relatedTarget && openBadge.contains(e.relatedTarget)) return;
      hide(openBadge);
    });

    /* Escape closes the popover only; capture phase keeps the quick view and
       cart drawer Escape handlers from also firing. */
    window.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape' || !openBadge) return;
      e.stopPropagation();
      hide(openBadge);
    }, true);

    function schedulePlace() {
      if (!openBadge || placeFrame) return;
      placeFrame = window.requestAnimationFrame(function() {
        placeFrame = null;
        if (!openBadge) return;
        if (!openBadge.isConnected) {
          openBadge = null;
          pinned = false;
          return;
        }
        place(openBadge);
      });
    }

    window.addEventListener('scroll', schedulePlace, { capture: true, passive: true });
    window.addEventListener('resize', schedulePlace);

    /* Badges inserted by script (e.g. the quick view) */
    document.addEventListener('promo:init', initAll);

    /* Collection grids swapped in by AJAX filtering */
    document.addEventListener('collection:swapped', function() {
      if (openBadge) hide(openBadge);
      initAll();
    });

    /* Product page variant switch: show only the badges whose promotion
       includes the selected variant. */
    document.addEventListener('product:variant-change', function(e) {
      var detail = e.detail || {};
      if (!detail.variantId) return;
      var scope = detail.scope || document;
      var needle = ',' + detail.variantId + ',';
      var badges = scope.querySelectorAll('[data-promo-badge][data-promo-variants]');
      for (var i = 0; i < badges.length; i++) {
        var matches = badges[i].getAttribute('data-promo-variants').indexOf(needle) > -1;
        if (!matches && badges[i] === openBadge) hide(badges[i]);
        badges[i].hidden = !matches;
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    (function() {
    var modal = document.querySelector('[data-quick-view]');
    var overlay = document.querySelector('[data-quick-view-overlay]');
    var content = document.querySelector('[data-quick-view-content]');
    var loading = document.querySelector('[data-quick-view-loading]');
    if (!modal || !content) return;

    var currentVariants = [];
    var currentProduct = null;
    /* Strength and review stats from the trigger's data attributes (not in the .js feed) */
    var currentExtras = {};
    var qvImageIndex = 0;

    /* The .js endpoint returns full-size originals; request a size that fits
       the gallery (about 2x its width) so switching images stays fast. */
    var QV_IMAGE_WIDTH = 900;

    function sizedImageUrl(url) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + QV_IMAGE_WIDTH;
    }

    function imagePath(url) {
      return String(url || '').split('?')[0].replace(/^https?:/, '');
    }

    function imageIndexOf(url) {
      if (!currentProduct || !currentProduct.images) return -1;
      var path = imagePath(url);
      for (var i = 0; i < currentProduct.images.length; i++) {
        if (imagePath(currentProduct.images[i]) === path) return i;
      }
      return -1;
    }

    function setActiveDot(index) {
      var dots = content.querySelectorAll('[data-qv-dot]');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
    }

    function formatMoney(amount) {
      var cents = (typeof amount === 'string') ? Math.round(parseFloat(amount) * 100) : amount;
      if (isNaN(cents)) return '$0.00';
      return '$' + (cents / 100).toFixed(2);
    }

    function open() {
      modal.classList.add('is-open');
      overlay.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-open');
      overlay.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      content.innerHTML = '';
      currentVariants = [];
      currentProduct = null;
    }

    function getVariantOption(variant, index) {
      if (variant.options && variant.options[index] !== undefined) return variant.options[index];
      return variant['option' + (index + 1)] || null;
    }

    function findVariant(options) {
      for (var i = 0; i < currentVariants.length; i++) {
        var v = currentVariants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (getVariantOption(v, j) !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function getSelectedOptions() {
      var selected = [];
      var groups = content.querySelectorAll('[data-qv-option-group]');
      for (var i = 0; i < groups.length; i++) {
        var active = groups[i].querySelector('.is-selected');
        if (active) selected.push(active.getAttribute('data-qv-option'));
      }
      return selected;
    }

    function updateVariant(variant) {
      var priceEl = content.querySelector('[data-qv-price]');
      var compareEl = content.querySelector('[data-qv-compare]');
      var selectEl = content.querySelector('[data-qv-variant-id]');
      var addBtn = content.querySelector('[data-qv-add-btn]');

      if (selectEl) selectEl.value = variant.id;
      showPromoBadgesFor(variant);

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var discountEl = content.querySelector('[data-qv-discount-pct]');
      if (compareEl) {
        if (variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (discountEl) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            discountEl.textContent = pct + '% off';
            discountEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
        }
      }

      if (addBtn) {
        var qvQtyWrap = content.querySelector('[data-qv-qty-wrap]');
        var qvNotifyLink = content.querySelector('[data-qv-notify-link]');

        if (variant.available) {
          addBtn.style.display = '';
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-text');
          if (qvQtyWrap) qvQtyWrap.style.display = '';
          if (qvNotifyLink) qvNotifyLink.style.display = 'none';
        } else {
          addBtn.style.display = 'none';
          if (qvQtyWrap) qvQtyWrap.style.display = 'none';
          if (qvNotifyLink) qvNotifyLink.style.display = '';
        }
      }

      if (variant.featured_image) {
        var mainImg = content.querySelector('[data-qv-main-image]');
        if (mainImg) mainImg.src = sizedImageUrl(variant.featured_image.src);

        var variantIndex = imageIndexOf(variant.featured_image.src);
        if (variantIndex > -1) qvImageIndex = variantIndex;
        setActiveDot(variantIndex);
      }
    }

    function escapeAttr(str) {
      return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    var STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

    function starsSvg() {
      var html = '';
      for (var i = 0; i < 5; i++) {
        html += '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
      }
      return html;
    }

    /* Stars and review count; hidden with no reviews, like the product page badge */
    function buildRatingHtml(product) {
      var count = parseInt(currentExtras.reviews, 10) || 0;
      var rating = parseFloat(currentExtras.rating) || 0;
      if (count < 1) return '';
      var countText = modal.getAttribute(count === 1 ? 'data-review-one' : 'data-review-other').replace('__count__', count);
      var label = modal.getAttribute('data-rating-label').replace('__rating__', rating.toFixed(1));
      var pct = Math.max(0, Math.min(100, rating / 5 * 100));
      return '<a href="/products/' + product.handle + '#judgeme_product_reviews" class="quick-view__rating">'
        + '<span class="quick-view__stars" role="img" aria-label="' + escapeAttr(label) + '">'
        + '<span class="quick-view__stars-empty">' + starsSvg() + '</span>'
        + '<span class="quick-view__stars-filled" style="width:' + pct + '%">' + starsSvg() + '</span>'
        + '</span>'
        + '<span class="quick-view__review-count">' + countText + '</span>'
        + '</a>';
    }

    /* Strength meter, same scale as the product page */
    function buildStrengthHtml() {
      var strength = currentExtras.strength;
      if (!strength) return '';
      var level = parseInt(currentExtras.strengthLevel, 10) || 0;
      var label = modal.getAttribute('data-strength-label');
      var html = '<div class="quick-view__strength">'
        + '<span class="quick-view__strength-label">' + label + '</span>';
      if (level > 0) {
        html += '<span class="quick-view__strength-meter" role="img" aria-label="' + escapeAttr(label + ': ' + strength) + '">';
        for (var i = 1; i <= 5; i++) {
          html += '<span class="quick-view__strength-step' + (i <= level ? ' is-filled' : '') + '"></span>';
        }
        html += '</span>';
      }
      html += '<span class="quick-view__strength-value">' + strength + '</span></div>';
      return html;
    }

    function buildModal(product) {
      currentProduct = product;
      currentVariants = product.variants || [];

      if (currentVariants.length === 0) {
        content.innerHTML = '<div class="quick-view__layout"><div class="quick-view__info" style="grid-column:1/-1;text-align:center;justify-content:center;">'
          + '<h2 class="quick-view__title">' + product.title + '</h2>'
          + '<a href="' + (product.url || '/products/' + product.handle) + '" class="btn btn--primary">View full details</a>'
          + '</div></div>';
        return;
      }

      var firstVariant = currentVariants[0];
      for (var vi = 0; vi < currentVariants.length; vi++) {
        if (currentVariants[vi].available) {
          firstVariant = currentVariants[vi];
          break;
        }
      }

      var galleryHtml = '';
      if (product.images && product.images.length > 0) {
        var mainSrc = (firstVariant.featured_image && firstVariant.featured_image.src)
          ? firstVariant.featured_image.src
          : product.images[0];
        qvImageIndex = Math.max(imageIndexOf(mainSrc), 0);
        galleryHtml += '<img src="' + sizedImageUrl(mainSrc) + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="quick-view__main-image" data-qv-main-image>';
        if (product.images.length > 1) {
          galleryHtml += '<button type="button" class="quick-view__nav quick-view__nav--prev" data-qv-prev aria-label="Previous image"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
          galleryHtml += '<button type="button" class="quick-view__nav quick-view__nav--next" data-qv-next aria-label="Next image"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>';
          galleryHtml += '<div class="quick-view__dots">';
          for (var i = 0; i < product.images.length; i++) {
            var activeClass = (i === qvImageIndex) ? ' is-active' : '';
            galleryHtml += '<button type="button" class="quick-view__dot' + activeClass + '" data-qv-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
          }
          galleryHtml += '</div>';
        }
      }

      var vendorHtml = product.vendor ? '<p class="quick-view__vendor">' + product.vendor + '</p>' : '';

      var priceHtml = '<div class="quick-view__price">';
      if (firstVariant.compare_at_price && parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price)) {
        var pct = Math.round((firstVariant.compare_at_price - firstVariant.price) / firstVariant.compare_at_price * 100);
        priceHtml += '<span class="quick-view__discount-pct" data-qv-discount-pct>' + pct + '% off</span>';
      } else {
        priceHtml += '<span class="quick-view__discount-pct" data-qv-discount-pct style="display:none"></span>';
      }
      priceHtml += '<span class="quick-view__price-current" data-qv-price>' + formatMoney(firstVariant.price) + '</span>';
      if (firstVariant.compare_at_price && parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price)) {
        priceHtml += '<span class="quick-view__price-compare" data-qv-compare>' + formatMoney(firstVariant.compare_at_price) + '</span>';
      } else {
        priceHtml += '<span class="quick-view__price-compare" data-qv-compare style="display:none"></span>';
      }
      priceHtml += '</div>';

      var descriptionHtml = '';
      if (product.description) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = product.description;
        var plainText = tempDiv.textContent || tempDiv.innerText || '';
        plainText = plainText.trim();
        if (plainText.length > 200) {
          plainText = plainText.substring(0, 200).replace(/\s+\S*$/, '') + '...';
        }
        if (plainText.length > 0) {
          descriptionHtml = '<div class="quick-view__description">' + plainText + '</div>';
        }
      }

      var optionsHtml = '';
      if (product.options && product.options.length > 0) {
        optionsHtml = '<div class="quick-view__options">';
        for (var o = 0; o < product.options.length; o++) {
          var opt = product.options[o];
          optionsHtml += '<div data-qv-option-group="' + o + '">';
          optionsHtml += '<span class="quick-view__option-label">' + opt.name + '</span>';
          optionsHtml += '<div class="quick-view__option-values">';
          for (var v = 0; v < opt.values.length; v++) {
            var val = opt.values[v];
            var selectedClass = (val === getVariantOption(firstVariant, o)) ? ' is-selected' : '';
            var priceLabel = '';
            var valAvailable = false;
            for (var vi = 0; vi < currentVariants.length; vi++) {
              if (getVariantOption(currentVariants[vi], o) === val) {
                if (priceLabel === '') priceLabel = formatMoney(currentVariants[vi].price);
                if (currentVariants[vi].available) valAvailable = true;
              }
            }
            var unavailClass = valAvailable ? '' : ' is-unavailable';
            optionsHtml += '<button type="button" class="quick-view__option-btn' + selectedClass + unavailClass + '" data-qv-option="' + val.replace(/"/g, '&quot;') + '" data-qv-option-index="' + o + '">'
              + '<span class="quick-view__option-name">' + val + '</span>'
              + (priceLabel ? '<span class="quick-view__option-price">' + priceLabel + '</span>' : '')
              + '</button>';
          }
          optionsHtml += '</div></div>';
        }
        optionsHtml += '</div>';
      }

      var notifyText = modal.getAttribute('data-notify-text') || 'Notify me when available';
      var formHtml = '<form action="/cart/add" method="post">'
        + '<input type="hidden" name="id" value="' + firstVariant.id + '" data-qv-variant-id>'
        + '<div class="quick-view__buy-row">'
        + '<div class="quick-view__qty-stepper" data-qv-qty-wrap' + (!firstVariant.available ? ' style="display:none"' : '') + '>'
        + '<button type="button" class="quick-view__qty-btn" data-qv-qty-minus aria-label="' + escapeAttr(modal.getAttribute('data-decrease-label')) + '">-</button>'
        + '<input type="number" name="quantity" value="1" min="1" class="quick-view__qty-input" data-qv-qty-input aria-label="' + escapeAttr(modal.getAttribute('data-quantity-label')) + '">'
        + '<button type="button" class="quick-view__qty-btn" data-qv-qty-plus aria-label="' + escapeAttr(modal.getAttribute('data-increase-label')) + '">+</button>'
        + '</div>'
        + '<button type="submit" class="btn btn--primary quick-view__add-btn" data-qv-add-btn data-add-text="Add to cart" data-sold-text="Sold out"' + (!firstVariant.available ? ' style="display:none"' : '') + '>Add to cart</button>'
        + '</div>'
        + '</form>'
        + '<a href="/products/' + product.handle + '" class="btn btn--primary quick-view__add-btn" data-qv-notify-link' + (firstVariant.available ? ' style="display:none"' : '') + '>' + notifyText + '</a>';

      var fullLink = '<a href="/products/' + product.handle + '" class="quick-view__full-link">View full details</a>';

      content.innerHTML = '<div class="quick-view__layout">'
        + '<div class="quick-view__gallery">' + galleryHtml + '</div>'
        + '<div class="quick-view__info">'
        + vendorHtml
        + '<h2 class="quick-view__title">' + product.title + '</h2>'
        + buildRatingHtml(product)
        + priceHtml
        + (currentExtras.promo || '')
        + buildStrengthHtml()
        + descriptionHtml
        + optionsHtml
        + formHtml
        + fullLink
        + '</div></div>';

      initModalEvents();
      preloadImages();
      if (currentExtras.promo) {
        document.dispatchEvent(new CustomEvent('promo:init'));
        showPromoBadgesFor(firstVariant);
      }
    }

    /* Free gift badges (snippets/promo-badge.liquid): only the offers that
       include the selected variant are shown. */
    function showPromoBadgesFor(variant) {
      if (!currentExtras.promo || !variant) return;
      document.dispatchEvent(new CustomEvent('product:variant-change', {
        detail: { variantId: variant.id, scope: content }
      }));
    }

    /* Warm the cache so the first switch to each image is instant */
    function preloadImages() {
      if (!currentProduct || !currentProduct.images) return;
      for (var i = 0; i < currentProduct.images.length; i++) {
        if (i === qvImageIndex) continue;
        new Image().src = sizedImageUrl(currentProduct.images[i]);
      }
    }

    function initModalEvents() {
      /* Gallery nav */
      var mainImg = content.querySelector('[data-qv-main-image]');
      var dots = content.querySelectorAll('[data-qv-dot]');
      var prevBtn = content.querySelector('[data-qv-prev]');
      var nextBtn = content.querySelector('[data-qv-next]');

      function goToImage(index) {
        if (!currentProduct || !currentProduct.images || !mainImg) return;
        var images = currentProduct.images;
        qvImageIndex = (index + images.length) % images.length;
        mainImg.src = sizedImageUrl(images[qvImageIndex]);
        setActiveDot(qvImageIndex);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goToImage(qvImageIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToImage(qvImageIndex + 1); });
      for (var i = 0; i < dots.length; i++) {
        dots[i].addEventListener('click', function() {
          goToImage(parseInt(this.getAttribute('data-qv-dot'), 10));
        });
      }

      /* Quantity stepper */
      var minusBtn = content.querySelector('[data-qv-qty-minus]');
      var plusBtn = content.querySelector('[data-qv-qty-plus]');
      var qtyInput = content.querySelector('[data-qv-qty-input]');
      if (minusBtn && plusBtn && qtyInput) {
        minusBtn.addEventListener('click', function() {
          var val = parseInt(qtyInput.value, 10);
          if (val > 1) qtyInput.value = val - 1;
        });
        plusBtn.addEventListener('click', function() {
          qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        });
      }

      /* Option buttons */
      var optionBtns = content.querySelectorAll('[data-qv-option]');

      function updateQvAvailability() {
        var selected = getSelectedOptions();
        var groups = content.querySelectorAll('[data-qv-option-group]');
        for (var g = 0; g < groups.length; g++) {
          var gIdx = parseInt(groups[g].getAttribute('data-qv-option-group'), 10);
          var btns = groups[g].querySelectorAll('[data-qv-option]');
          for (var b = 0; b < btns.length; b++) {
            var val = btns[b].getAttribute('data-qv-option');
            var hasAvail = false;
            for (var vi = 0; vi < currentVariants.length; vi++) {
              if (getVariantOption(currentVariants[vi], gIdx) !== val) continue;
              var match = true;
              for (var s = 0; s < selected.length; s++) {
                if (s === gIdx) continue;
                if (getVariantOption(currentVariants[vi], s) !== selected[s]) { match = false; break; }
              }
              if (match && currentVariants[vi].available) { hasAvail = true; break; }
            }
            if (hasAvail) { btns[b].classList.remove('is-unavailable'); }
            else { btns[b].classList.add('is-unavailable'); }
          }
        }
      }

      for (var i = 0; i < optionBtns.length; i++) {
        optionBtns[i].addEventListener('click', function() {
          var group = this.closest('[data-qv-option-group]');
          var siblings = group.querySelectorAll('[data-qv-option]');
          for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('is-selected');
          this.classList.add('is-selected');

          var selected = getSelectedOptions();
          var variant = findVariant(selected);
          if (variant) updateVariant(variant);
          updateQvAvailability();
        });
      }
    }

    function loadProduct(handle, trigger) {
      currentExtras = trigger ? {
        strength: trigger.getAttribute('data-qv-strength'),
        strengthLevel: trigger.getAttribute('data-qv-strength-level'),
        rating: trigger.getAttribute('data-qv-rating'),
        reviews: trigger.getAttribute('data-qv-reviews'),
        promo: trigger.getAttribute('data-qv-promo')
      } : {};
      loading.classList.add('is-loading');
      content.innerHTML = '';
      open();

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          loading.classList.remove('is-loading');
          if (data) {
            buildModal(data);
          }
        })
        .catch(function(err) {
          console.error('Quick view error:', err);
          loading.classList.remove('is-loading');
          close();
        });
    }

    /* --- Event listeners --- */

    overlay.addEventListener('click', close);

    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-quick-view-close]')) close();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    /* Trigger from product cards */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-quick-view-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var handle = trigger.getAttribute('data-quick-view-trigger');
        if (handle) loadProduct(handle, trigger);
      }
    });

    /* Close quick view when cart drawer opens (item was added) */
    var cartDrawerEl = document.querySelector('[data-cart-drawer]');
    if (cartDrawerEl) {
      new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (cartDrawerEl.classList.contains('is-open') && modal.classList.contains('is-open')) {
            close();
            break;
          }
        }
      }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
